document.addEventListener('DOMContentLoaded', function () {
  const dots = document.querySelectorAll('.lookbook-dot');

  dots.forEach(dot => {
    const item = dot.closest('.lookbook-item'); // main image container
    const hoverWrapper = item.querySelector('.lookbook-hover-wrapper');
    const link = item.querySelector('.lookbook-hover-link');
    let tapped = false;

    // Desktop hover
    dot.addEventListener('mouseenter', () => {
      if (window.innerWidth >= 750 && hoverWrapper) hoverWrapper.style.display = 'block';
    });
    dot.addEventListener('mouseleave', () => {
      if (window.innerWidth >= 750 && hoverWrapper) hoverWrapper.style.display = 'none';
    });

    if (hoverWrapper) {
      hoverWrapper.addEventListener('mouseenter', () => {
        if (window.innerWidth >= 750) hoverWrapper.style.display = 'block';
      });
      hoverWrapper.addEventListener('mouseleave', () => {
        if (window.innerWidth >= 750) hoverWrapper.style.display = 'none';
      });
    }

    // Mobile two-step click
    dot.addEventListener('click', function (e) {
      if (window.innerWidth < 750 && hoverWrapper) {
        e.preventDefault();
        if (!tapped) {
          // First tap: show hover popup
          tapped = true;
          hoverWrapper.style.display = 'block';
        } else {
          // Second tap: follow product link
          if (link && link.href) {
            window.location.href = link.href;
          }
        }
      }
    });

    // Hide hover popup if clicking outside
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.lookbook-item')) {
        if (window.innerWidth < 750 && hoverWrapper) {
          hoverWrapper.style.display = 'none';
          tapped = false;
        }
      }
    });
  });
});
